module.exports = __webpack_public_path__ + "media/images/card-mastercard-49e6822eef8f162f0d76f27f651376d8.svg";